import { Route, Routes } from 'react-router-dom'

import TaskListTemplateEdit from './screens/TaskListTemplate/screens/Edit'
import TaskListTemplateList from './screens/TaskListTemplate/screens/List'

const QualityControlRoutes = () => (
  <Routes>
    <Route path="/taskListTemplates" element={<TaskListTemplateList />} />
    <Route path="/taskListTemplates/:taskListTemplateId/edit/*" element={<TaskListTemplateEdit />} />
  </Routes>
)

export default QualityControlRoutes
